// ---------------------------------------------------------------------------
// Confirm guard. Replaces inline `onclick="return confirm(…)"` (blocked by the
// /Admin CSP, which has no 'unsafe-inline' for scripts) with a delegated submit
// listener. Put `data-confirm="message"` on the submit button, or on the form.
// ---------------------------------------------------------------------------

export function initConfirm(): void {
  document.addEventListener(
    "submit",
    (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;

      const submitter = (event as SubmitEvent).submitter as HTMLElement | null;
      const message =
        submitter?.getAttribute("data-confirm") ??
        form.getAttribute("data-confirm");

      if (message && !window.confirm(message)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    // capture so we run before the default submit
    true,
  );
}
